const Storage = {
  setItem(key, val) {
    val = JSON.stringify(val);
    window.sessionStorage.setItem(key, val); //使用非持久化缓存是因为微信端没有统一入口页，不好统一调用缓存版本控制接口
  },

  getItem(key) {
    let val: any = window.sessionStorage.getItem(key);
    if (val === null) {
      return null;
    } else {
      try {
        val = JSON.parse(val);
      } catch (err) {
        //todo
      }
      return val;
    }
  }
};

export default Storage;
